import { Card, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { categoryLogos } from "../constants/categoryAssets";

export default function CategoryCard({ category, onClick }) {
  const theme = useTheme();
  const logo = categoryLogos[category.id];
  const gradient = theme.custom.gradients[category.id] || theme.custom.gradients.default;

  return (
    <Card
      onClick={onClick}
      sx={{
        cursor: "pointer",
        borderRadius: 2,
        background: gradient,
        width: "100%",
        maxWidth: 240,
        aspectRatio: "2 / 3",
        display: "flex",
        alignItems: "center",
    justifyContent: "center",
        position: "relative",
        overflow: "hidden",
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-8px)",
          boxShadow: theme.custom.shadow.strong,
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at top, rgba(255,255,255,0.25), transparent 60%)",
          opacity: 0.6,
        }}
      />

      {/* Logo */}
      {logo && (
        <Box
          component="img"
          src={logo}
          alt={category.name}
          sx={{
            width: "60%",          // ✅ proportionnel
            height: "40%",
            objectFit: "contain",  // ✅ proportions respectées
            position: "relative",
            zIndex: 1,
            filter: "drop-shadow(0 8px 16px rgba(0,0,0,0.4))",
          }}
        />
      )}
    </Card>
  );
}
